export default "/images/668bbf84b998c657e17939721c3181d1.avif";